import React from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import NurseProfilePic from "../../assets/images/Nurse-profile-pic.png";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { de } from "@faker-js/faker";
import { useTranslation } from 'react-i18next';



const NurseProfileModal = ({ show, onClose, nurse, selectedType }) => {
    // debugger
    console.log("NurseProfileModal nurse:", nurse);
    const { t, i18n } = useTranslation();
     const emailId = useSelector((state) => state.userData);
  const [profile, setProfile] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  
  

  React.useEffect(() => {
    if (show && nurse) {
      const token = localStorage.getItem("AccessToken");
      setLoading(true);
      const params = {
        NurseName: nurse.NurseFullName || nurse.NurseName,
        MemberId: emailId.userData.MemberID,
        Role: "RN",
        Contract: emailId.userData.ContractIdentified,
        EmailID: emailId.userData.EmailID,
        IsFavouriteFlag: "",
        DeviceType: "PatientPortal"
      };
      debugger
      axios
        .post(
          Endpoints.LoadNCAProfileDetails,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
            // debugger
          // Map the array response to a profile object
          if (Array.isArray(res.data) && res.data.length > 0) {
            const arr = res.data;
            const profile = {
              DisplayNurseName: arr[0].DisplayNurseName,
              NurseImgURL: arr[0].NurseImgURL,
              IsPrimaryStatus: nurse.IsPrimaryStatus,
              QnA: arr.map(item => ({
                question: item.NCAQuestions,
                answer: item.NCAAnswers
              }))
            };
            setProfile(profile);
          } else {
            setProfile(null);
          }
        })
        .catch(() => setProfile(null))
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      setProfile(null);
    }
  }, [show, nurse]);

  if (!nurse) return null;
  return (
    <Modal show={show} onHide={onClose} centered className="custom-modal">
      <Modal.Body className="text-center" style={{ color: "#111" }}>
       
        {loading ? (
         <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
        ) : (profile &&
  Array.isArray(profile.QnA) &&
  profile.QnA.some(item => item.question || item.answer)
) ? (
          <>
           <div style={{ color: '#111', fontWeight: 500, fontSize: 18, marginBottom: 10 }}>
           Get to know your Care Advocate
        </div>
            <img
              src={profile.NurseImgURL || NurseProfilePic}
              alt={profile.DisplayNurseName}
              style={{ width: 120, height: 120, borderRadius: "100%", objectFit: "cover", marginBottom: 10 }}
              />
           
           
             <div style={{ color:'black' }}>
           </div>
            <div style={{ fontWeight: "bold", fontSize: 22, marginBottom: 8, color: '#111' }}>
              {profile.DisplayNurseName}
            {selectedType === "Nurse" && (
            <span className={`favorites-icon ${nurse.IsPrimaryStatus === "P" ? "favsaved" : ""}`} style={{ marginLeft: 8, fontSize: 22 }}></span>
          )}            </div>
            <div style={{ textAlign: "left", margin: "0 auto", maxWidth: 420 }}>
              {profile.QnA.map((item, idx) => (
                <div key={idx} style={{ marginBottom: 8 }}>
                  <span style={{ color: '#111', fontSize: 18 , fontWeight: 500 }}>{item.question}</span>
                  <div style={{ color: "#303030", fontSize: 16  }}>{item.answer || "-"}</div>
                </div>
              ))}
            </div>
            {selectedType === "Nurse" && (
            <>
            {profile.IsPrimaryStatus === "N" && (
              <button
                className="win-model-btn-outline mt-3"
                style={{ border: "2px solid #111", color: "#111", background: "transparent", borderRadius: 30, padding: "8px 24px", fontWeight: 600, fontSize: 16, marginBottom: 10, width: '100%' }}
                onClick={() => {
                  onClose();
                  if (typeof window.handleToggleFavoriteFromModal === 'function') {
                    window.handleToggleFavoriteFromModal(nurse);
                  }
                }}
              >
                {`Make ${profile.DisplayNurseName?.split(' ')[0] || 'Nurse'} My Primary NCA`}
              </button>
            )}</>)} 
            <button className="win-model-btn-primary mt-3"  onClick={onClose}>
              Close
            </button>
          </>
        ) : (
        <div style={{ color: "#111", position: "relative", minHeight: 40 }}>
    <button
      style={{
        position: "absolute",
        top: "-30px",
        right:"-40px",
        background: "transparent",
        border: "none",
        fontSize: 22,
        color: "#111",
        cursor: "pointer"
      }}
      onClick={onClose}
      aria-label="Close"
    >
      &times;
    </button>
    <div style={{ paddingTop: 10 }}>Profile information is not available for this nurse.</div>
  </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NurseProfileModal;
